import React, {Component} from 'react'
import {Field} from 'redux-form'
import PropTypes from 'prop-types'
import cx from 'classnames'

import {enableUniqueIds} from '@cred/shared/unique-id'
import Font from '@cred/react-font'
import {renderError} from '@cred/react-form-field'
import analytics from '@cred/react-analytics/hoc/emitOnChange'

import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import thebalance1 from './themes/thebalance1/styles.module.scss'
import investopedia1 from './themes/investopedia1/styles.module.scss'
import forbes1 from './themes/forbes1/styles.module.scss'
import yahoo1 from './themes/yahoo1/styles.module.scss'
import homes1 from './themes/homes1/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'

import withStyles from '@cred/react-theme'

class radioButton extends Component {
  render() {
    const {
        meta: {touched, error},
        input,
        id,
        label,
        size,
        styles,
        branding,
        maskedField,
        className
      } = this.props,
      onKeyPress = e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          const {value, onChange} = input

          onChange(value)
        }
      }

    return (
      <div className={cx(className, styles.radioButton, styles[size], branding.radioButtonContainer, {
        [styles.error]: !maskedField && touched && error
      })} onKeyPress={onKeyPress}>
        <input type="radio" id={id} {...input} hidden/>
        <label className={branding.radioButtonLabel} htmlFor={id} role="radio" tabIndex={0} aria-checked={input.checked}>
          <Font>{label}</Font>
        </label>
      </div>
    )
  }
}

const radioButtonWithAnalytics = /*#__PURE__*/ analytics(radioButton)

/**
 * @visibleName Radio Group
 */
class RadioGroup extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['normal', 'small']),
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.bool
        ]),
        label: PropTypes.string
      })
    ).isRequired,
    className: PropTypes.string,
    groupLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    mobileGroupLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    branding: PropTypes.shape({
      radioButtonContainer: PropTypes.string,
      radioButtonLabel: PropTypes.string
    }),
    maskedField: PropTypes.bool,
    wrapperClassName: PropTypes.string,
    buttonClassName: PropTypes.string
  }

  static defaultProps = {
    size: 'normal',
    branding: {},
    maskedField: false,
    wrapperClassName: '',
    buttonClassName: ''
  }

  constructor(props) {
    super(props)
    enableUniqueIds(this)
  }

  render() {
    const {
      className,
      options,
      groupLabel,
      mobileGroupLabel,
      styles = defaultStyles,
      branding,
      maskedField,
      wrapperClassName,
      buttonClassName,
      ...props
    } = this.props

    return (
      <div className={className}>
        <Font className="hidden-xs hidden-sm mb-8">
          {groupLabel}
        </Font>
        <Font className="hidden-md hidden-lg hidden-xl mb-8">
          {mobileGroupLabel || groupLabel}
        </Font>
        <div className={cx(styles.radioButtonsWrapper, wrapperClassName)} role="radiogroup">
          {options.map((option, index) =>
            <Field
              key={`radio-group${index}`}
              type="radio"
              component={radioButtonWithAnalytics}
              id={index + this.nextUniqueId()}
              label={option.label}
              value={option.value}
              styles={styles}
              branding={branding}
              maskedField={maskedField}
              className={buttonClassName}
              {...props}
            />
          )}
          {!maskedField && <Field name={props.name} component={renderError} {...props}/>}
        </div>
      </div>
    )
  }
}

export {RadioGroup as RadioGroupNoHoc}

export default /*#__PURE__*/ withStyles(
  defaultStyles, {
    fox1,
    thebalance1,
    investopedia1,
    forbes1,
    yahoo1,
    homes1,
    credible3
  }
)(RadioGroup)
